import type { ComponentProps } from "react";
import type { ModelProviderId } from "@/lib/ai/models";
import { cn } from "@/lib/utils";

type Props = ComponentProps<"svg"> & {
  provider: ModelProviderId;
};

/** Renders the recognizable mark for each provider without coupling it to a brand color. */
export function ModelProviderIcon({ provider, className, ...props }: Props) {
  if (provider === "openai") {
    return (
      <svg
        aria-hidden="true"
        viewBox="0 0 24 24"
        className={cn("size-4", className)}
        {...props}
      >
        <path
          fill="currentColor"
          d="M22.282 9.821a5.985 5.985 0 0 0-.516-4.911 6.046 6.046 0 0 0-6.51-2.9A6.065 6.065 0 0 0 4.981 4.182a5.985 5.985 0 0 0-3.998 2.9 6.046 6.046 0 0 0 .743 7.097 5.98 5.98 0 0 0 .511 4.911 6.051 6.051 0 0 0 6.515 2.9A5.984 5.984 0 0 0 13.26 24a6.056 6.056 0 0 0 5.772-4.206 5.989 5.989 0 0 0 3.998-2.9 6.056 6.056 0 0 0-.748-7.073Zm-9.022 12.608a4.476 4.476 0 0 1-2.877-1.041l.142-.08 4.778-2.758a.795.795 0 0 0 .393-.682v-6.737l2.02 1.169a.071.071 0 0 1 .038.052v5.583a4.504 4.504 0 0 1-4.494 4.494Zm-9.661-4.125a4.471 4.471 0 0 1-.535-3.014l.142.085 4.783 2.758a.771.771 0 0 0 .781 0l5.843-3.369v2.333a.08.08 0 0 1-.033.061L9.74 19.95a4.499 4.499 0 0 1-6.141-1.646ZM2.341 7.896a4.485 4.485 0 0 1 2.365-1.973V11.6a.766.766 0 0 0 .388.677l5.814 3.354-2.02 1.169a.076.076 0 0 1-.071 0l-4.83-2.787A4.504 4.504 0 0 1 2.34 7.872Zm16.596 3.856-5.833-3.388L15.119 7.2a.076.076 0 0 1 .071 0l4.83 2.791a4.494 4.494 0 0 1-.676 8.104v-5.677a.79.79 0 0 0-.407-.667Zm2.011-3.024-.142-.085-4.774-2.782a.776.776 0 0 0-.785 0L9.409 9.23V6.897a.066.066 0 0 1 .028-.061l4.83-2.787a4.499 4.499 0 0 1 6.681 4.66ZM8.307 12.863l-2.02-1.164a.08.08 0 0 1-.038-.057V6.074a4.499 4.499 0 0 1 7.376-3.454l-.142.081-4.778 2.758a.795.795 0 0 0-.393.682Zm1.097-2.365 2.602-1.5 2.607 1.5v2.999l-2.597 1.5-2.607-1.5Z"
        />
      </svg>
    );
  }

  if (provider === "anthropic") {
    return (
      <svg
        aria-hidden="true"
        viewBox="0 0 12 12"
        className={cn("size-4", className)}
        {...props}
      >
        <path
          fill="currentColor"
          d="m2.355 7.978 2.36-1.324.04-.115-.04-.064H4.6l-4.047-.17L.268 6.245 0 5.892l.028-.176.24-.16 4.292.336h.195l.027-.079-.119-.097L.997 3.112l-.08-.505.329-.36.44.03 2.942 2.18.072-.052.01-.036L2.82.938c-.033-.12-.05-.242-.052-.365L3.142.067 3.348 0l.498.067.21.182 1.817 3.785.121.416.046.128h.079v-.073l.338-3.628.188-.455.373-.246.292.14.24.342-.606 3.57h.106l2.504-2.883h.516l.38.564-.17.583-2 2.775.037.055.094-.01 3.537-.6.417.193.045.198-.164.403-3.88.896.025.03 3.82.204.395.261.237.319-.04.242-.607.31-3.482-.814h-.091v.055l2.868 2.604.063.289-.161.227-.17-.024-2.555-2.012h-.064v.085l1.456 2.625.061.54-.085.176-.304.107-.334-.061-2.036-3.017-.07.04-.495 3.812-.365.14-.303-.231-.16-.373.655-3.732-.006-.021-.07.009-2.67 3.46-.207.082-.358-.185.033-.331 2.58-3.296-.003-.079h-.028L1.5 9.353l-.243-.228.03-.373.116-.121.952-.653Z"
        />
      </svg>
    );
  }

  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      className={cn("size-4", className)}
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 2c-.78 5.22-4.78 9.22-10 10 5.22.78 9.22 4.78 10 10 .78-5.22 4.78-9.22 10-10-5.22-.78-9.22-4.78-10-10Z"
      />
    </svg>
  );
}
